import {TableButton} from "@ui/buttons/TableButton";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

const UserImage = ({
  photoFile,
  editUser,
  user,
  photoImage,
  onClick,
  onClickDelete,
}) => {
  const imageSrc = photoFile
    ? URL.createObjectURL(photoFile)
    : editUser?.cover || user?.cover;

  const {t} = useTranslation();

  return (
    <div className={styles.userImageWrapper}>
      <div className={styles.userImage}>
        <img
          className={styles.userPreview}
          alt={"preview"}
          style={!imageSrc ? {background: "var(--greyLight)"} : {}}
          src={imageSrc}
        />

        {photoImage && !imageSrc && (
          <img
            onClick={onClick}
            className={styles.photoImage}
            src={photoImage}
            alt={"photo"}
          />
        )}
      </div>

      {imageSrc && (
        <div className={styles.userImageBtns}>
          {onClick && (
            <TableButton
              icon={"update"}
              color={"var(--violetDark)"}
              label={"Update"}
              action={"item"}
              onClickAction={() => onClick()}
            />
          )}

          {onClickDelete && (
            <TableButton
              icon={"delete"}
              color={"var(--red)"}
              label={t("table.button.delete")}
              action={"delete"}
              onClickAction={() => onClickDelete()}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default UserImage;
